module.exports = __webpack_public_path__ + "static/media/resume.7e52e31b.pdf";